import { render } from "./ThemeConfigs.vue?vue&type=template&id=0a27689c&scoped=true"
import script from "./ThemeConfigs.vue?vue&type=script&lang=js"
export * from "./ThemeConfigs.vue?vue&type=script&lang=js"

import "./ThemeConfigs.vue?vue&type=style&index=0&id=0a27689c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a27689c"]])

export default __exports__